<div class="exw-shell" data-source="scoped_example">
  <aside class="exw-rail" aria-label="Product map">
    <div class="exw-rail-brand">
      <img src="assets/images/SuperSee_horizontal_white_text_transparent_bg.webp" alt="SuperSee" class="exw-rail-lockup" />
    </div>
    <div class="exw-rail-nav" role="navigation" aria-label="Product sections">
      <ng-container *ngFor="let item of previewNav">
        <div
          *ngIf="item.stepId as stepId; else lockedNav"
          class="exw-rail-row"
          [class.is-active]="isPreviewStepActive(stepId)"
          role="button"
          tabindex="0"
          [attr.aria-current]="isPreviewStepActive(stepId) ? 'page' : null"
          (click)="selectPreviewStep(stepId)"
          (keydown.enter)="selectPreviewStep(stepId)"
          (keydown.space)="$event.preventDefault(); selectPreviewStep(stepId)">
          <h3>
            <span class="material-symbols-outlined" aria-hidden="true">{{ item.icon }}</span>
            <span>{{ item.label }}</span>
          </h3>
        </div>
        <ng-template #lockedNav>
          <div
            class="exw-rail-row is-gated"
            role="button"
            tabindex="0"
            [matTooltip]="laterHint"
            matTooltipPosition="right"
            [attr.aria-expanded]="gatedTeaseOpen && gatedTeaseItem === item.id ? true : null"
            (click)="onGatedRailClick(item.id)"
            (keydown.enter)="onGatedRailClick(item.id)"
            (keydown.space)="$event.preventDefault(); onGatedRailClick(item.id)">
            <h3>
              <span class="material-symbols-outlined" aria-hidden="true">{{ item.icon }}</span>
              <span>{{ item.label }}</span>
            </h3>
          </div>
        </ng-template>
      </ng-container>

      <div class="exw-rail-row exw-rail-row--parent" [class.is-section-active]="isReportsSectionActive()">
        <h3>
          <span class="material-symbols-outlined" aria-hidden="true">bar_chart</span>
          <span>Reports</span>
          <span class="material-symbols-outlined exw-rail-expand" aria-hidden="true">expand_more</span>
        </h3>
      </div>
      <div class="exw-rail-submenu">
        <div
          class="exw-rail-row exw-rail-row--child"
          *ngFor="let child of previewReportChildren"
          [class.is-active]="isPreviewStepActive(child.stepId)"
          role="button"
          tabindex="0"
          [attr.aria-current]="isPreviewStepActive(child.stepId) ? 'page' : null"
          (click)="selectPreviewStep(child.stepId)"
          (keydown.enter)="selectPreviewStep(child.stepId)"
          (keydown.space)="$event.preventDefault(); selectPreviewStep(child.stepId)">
          <h4>
            <span class="material-symbols-outlined" aria-hidden="true">{{ child.icon }}</span>
            <span>{{ child.label }}</span>
          </h4>
        </div>
      </div>

      <div
        class="exw-rail-row is-gated"
        role="button"
        tabindex="0"
        [matTooltip]="laterHint"
        matTooltipPosition="right"
        [attr.aria-expanded]="gatedTeaseOpen && gatedTeaseItem === 'settings' ? true : null"
        (click)="onGatedRailClick('settings')"
        (keydown.enter)="onGatedRailClick('settings')"
        (keydown.space)="$event.preventDefault(); onGatedRailClick('settings')">
        <h3>
          <span class="material-symbols-outlined" aria-hidden="true">settings</span>
          <span>Settings</span>
        </h3>
      </div>
      <div
        class="exw-rail-row is-gated exw-rail-row--section"
        role="button"
        tabindex="0"
        [matTooltip]="laterHint"
        matTooltipPosition="right"
        [attr.aria-expanded]="gatedTeaseOpen && gatedTeaseItem === 'help' ? true : null"
        (click)="onGatedRailClick('help')"
        (keydown.enter)="onGatedRailClick('help')"
        (keydown.space)="$event.preventDefault(); onGatedRailClick('help')">
        <h3>
          <span class="material-symbols-outlined" aria-hidden="true">help</span>
          <span>Help &amp; Support</span>
        </h3>
      </div>
    </div>
    <p class="exw-rail-footnote">Preview · sample data</p>
  </aside>

  <div #exwPage class="container-fluid work-replay-page exw-page">
  <div class="exw-sample-banner" role="status">
    <mat-icon fontSet="material-symbols-outlined">info</mat-icon>
    <span>{{ workday.bannerLabel }}</span>
  </div>

  <div
    class="exw-gated-tease"
    *ngIf="gatedTeaseOpen"
    role="dialog"
    aria-modal="true"
    aria-labelledby="exw-gated-tease-title">
    <h2 id="exw-gated-tease-title" class="exw-gated-tease-title">{{ gatedTeaseTitle }}</h2>
    <p class="exw-gated-tease-body">{{ gatedTeaseBody }}</p>
    <div class="exw-gated-tease-actions">
      <button mat-flat-button class="exw-btn-primary" type="button" (click)="tryOneEmployee()">
        {{ gatedTeasePrimary }}
        <mat-icon fontSet="material-symbols-outlined">arrow_forward</mat-icon>
      </button>
      <button mat-stroked-button type="button" (click)="dismissGatedTease()">
        {{ gatedTeaseSecondary }}
      </button>
    </div>
  </div>

  <header class="exw-orient">
    <div class="exw-orient-top">
      <div class="exw-orient-copy">
        <h1 class="exw-orient-title">{{ currentStep.label }}</h1>
        <p class="exw-orient-body">{{ identityLine }} · sample day</p>
      </div>
      <button type="button" mat-stroked-button class="exw-exit-btn exw-exit-btn--header" (click)="exitExample()">
        {{ workday.exitLabel }}
      </button>
    </div>
  </header>

  <div class="exw-progress exw-progress--mobile" role="navigation" aria-label="Example workday sections">
    <button
      type="button"
      class="exw-progress-step"
      *ngFor="let step of workday.steps; let i = index"
      [class.is-current]="stepState(i) === 'current'"
      [class.is-done]="stepState(i) === 'done'"
      [class.is-upcoming]="stepState(i) === 'upcoming'"
      [attr.aria-current]="stepState(i) === 'current' ? 'step' : null"
      (click)="selectStep(i)"
    >
      <span class="exw-progress-num" aria-hidden="true">{{ i + 1 }}</span>
      <span class="exw-progress-label">{{ step.label }}</span>
    </button>
  </div>

  <div class="wr-main-card fluid-ss exw-main-card">
    <div class="exw-step-intro">
      <div class="exw-step-intro-text">
        <p class="exw-step-product">{{ currentStep.label }}</p>
        <h2>{{ currentStep.question }}</h2>
        <p>{{ currentStep.narrative }}</p>
      </div>
      <p class="exw-takeaway" *ngIf="currentStep.takeaway">
        <mat-icon fontSet="material-symbols-outlined" aria-hidden="true">lightbulb</mat-icon>
        <span>{{ currentStep.takeaway }}</span>
      </p>
    </div>

    <!-- Replay: Work Replay summary + buckets -->
    <div class="exw-wr" *ngIf="currentStep.id === 'replay'">
      <div class="exw-summary-row" aria-label="Work Replay summary">
        <div class="exw-summary-card">
          <span class="exw-summary-label">Usage</span>
          <strong>{{ workday.totals.usage }}</strong>
        </div>
        <div class="exw-summary-card">
          <span class="exw-summary-label">Idle</span>
          <strong>{{ workday.totals.idle }}</strong>
        </div>
        <div class="exw-summary-card exw-summary-card--wide">
          <span class="exw-summary-label">First–last activity</span>
          <strong>{{ workday.totals.firstSeen }}–{{ workday.totals.lastSeen }}</strong>
        </div>
      </div>

      <div class="wr-buckets wr-timeline">
        <div class="wr-step" *ngFor="let bucket of workday.replayBuckets">
          <div class="wr-step-left">
            <span
              class="wr-node-dot"
              [class.wr-node-dot--usage]="bucket.kind === 'usage'"
              [class.wr-node-dot--idle]="bucket.kind === 'idle'"
              [class.wr-node-dot--mixed]="bucket.kind === 'mixed'"
            ></span>
          </div>
          <div class="wr-step-right">
            <div class="wr-bucket-row" [class.wr-bucket-row--with-shots]="!!bucket.cards?.length">
              <div class="wr-bucket-summary wr-bucket-summary--compact">
                <div class="wr-bucket-left">
                  <div class="wr-bucket-time-row">
                    <span class="wr-bucket-label">{{ bucket.range }}</span>
                    <span
                      class="wr-state-chip"
                      [class.wr-state-chip--usage]="bucket.kind === 'usage'"
                      [class.wr-state-chip--idle]="bucket.kind === 'idle'"
                      [class.wr-state-chip--mixed]="bucket.kind === 'mixed'"
                    >{{ bucket.label }}</span>
                  </div>
                  <div class="wr-bucket-time-sub" *ngIf="bucket.idleNote">{{ bucket.idleNote }}</div>
                </div>
                <div class="wr-bucket-head-end" *ngIf="bucket.cards?.length">
                  <div class="wr-bucket-mid">
                    <div class="wr-bucket-mid-primary">{{ bucket.cards.length }} screenshot{{ bucket.cards.length === 1 ? '' : 's' }}</div>
                  </div>
                </div>
              </div>

              <div class="wr-bucket-expanded" *ngIf="bucket.cards?.length">
                <div class="wr-ss-grid">
                  <div class="wr-ss-card" *ngFor="let card of bucket.cards">
                    <div class="wr-ss-media-frame">
                      <img class="wr-ss-img" [src]="card.imageSrc" [alt]="card.appName" loading="lazy" />
                    </div>
                    <div class="wr-ss-meta">
                      <div class="wr-ss-meta-top">
                        <div class="ss-card-app wr-ss-meta-app">
                          <div class="ss-card-app-icon-wrap" aria-hidden="true">
                            <mat-icon class="ss-card-app-icon-fallback" fontSet="material-symbols-outlined">web_asset</mat-icon>
                          </div>
                          <div class="wr-ss-meta-app-text">
                            <span class="ss-card-app-name wr-ss-app-title" [title]="card.appName">{{ card.appName }}</span>
                            <div class="screenshot-time-compact wr-ss-time">
                              <span class="screenshot-time-primary-sm">{{ card.time }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="screenshot-type-chip wr-ss-type-chip">
                          <span class="material-symbols-outlined chip-ic">schedule</span>
                          <span>{{ card.trigger }}</span>
                        </div>
                      </div>
                      <div class="wr-ss-meta-footer">
                        <span class="wr-ss-window">{{ card.windowName }}</span>
                        <span class="wr-ss-window" *ngIf="card.note">{{ card.note }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Usage: Apps & Websites — mirrors /reports layout -->
    <div class="exw-usage" *ngIf="currentStep.id === 'usage'">
      <div class="exw-rpt-header">
        <div>
          <h2 class="exw-rpt-title">Apps &amp; Websites</h2>
          <p class="exw-rpt-subtitle">Usage analytics dashboard</p>
        </div>
        <span class="exw-rpt-filter" aria-hidden="true">
          <span class="material-symbols-outlined">filter_alt</span>
          {{ workday.usageFilterLabel }}
        </span>
      </div>

      <div class="exw-rpt-stats">
        <div class="exw-rpt-stat" *ngFor="let stat of workday.usageStats">
          <div class="exw-rpt-stat-icon" [attr.data-tone]="stat.tone">
            <span class="material-symbols-outlined">{{ stat.icon }}</span>
          </div>
          <div class="exw-rpt-stat-body">
            <span class="exw-rpt-stat-label">{{ stat.label }}</span>
            <strong class="exw-rpt-stat-value">{{ stat.value }}</strong>
            <span class="exw-rpt-stat-sub" *ngIf="stat.subtitle">{{ stat.subtitle }}</span>
          </div>
        </div>
      </div>

      <div class="exw-rpt-charts">
        <section class="exw-rpt-chart-card">
          <h3>Top Usage by Time</h3>
          <div class="exw-rpt-top-list" role="img" [attr.aria-label]="'Top apps and websites by time'">
            <div class="exw-rpt-top-row" *ngFor="let row of topUsageChartRows; let i = index; trackBy: trackByUsageName">
              <span class="exw-rpt-top-name">{{ row.name }}</span>
              <div class="exw-rpt-top-track">
                <div
                  class="exw-rpt-top-fill"
                  [style.width.%]="topUsageBarPercent(row)"
                  [style.background]="usageBarColor(i)"></div>
              </div>
              <span class="exw-rpt-top-hours">{{ row.duration }}</span>
            </div>
            <div class="exw-rpt-top-axis" aria-hidden="true">
              <span>0h</span>
              <span>1h</span>
              <span>2h</span>
              <span>3h</span>
            </div>
          </div>
        </section>

        <section class="exw-rpt-chart-card">
          <div class="exw-rpt-chart-head">
            <h3>Daily Usage Trend</h3>
            <div class="exw-rpt-legend" aria-hidden="true">
              <span><i [style.background]="trendAppColor"></i> Apps</span>
              <span><i [style.background]="trendWebColor"></i> Websites</span>
            </div>
          </div>
          <div class="exw-rpt-trend" role="img" [attr.aria-label]="'Daily apps and websites usage trend'">
            <div class="exw-rpt-trend-y" aria-hidden="true">
              <span *ngFor="let tick of trendYTicksDesc; trackBy: trackByIndex">{{ tick }}h</span>
            </div>
            <div class="exw-rpt-trend-plot">
              <svg viewBox="0 0 100 100" preserveAspectRatio="none" class="exw-rpt-trend-svg">
                <g *ngFor="let tick of trendYTicks; trackBy: trackByIndex">
                  <line
                    x1="0"
                    [attr.y1]="100 - (tick / trendMaxHours) * 100"
                    x2="100"
                    [attr.y2]="100 - (tick / trendMaxHours) * 100"
                    stroke="#e5e7eb"
                    stroke-width="0.4"
                    vector-effect="non-scaling-stroke"></line>
                </g>
                <path
                  [attr.d]="trendAreaPath('apps')"
                  [attr.fill]="trendAppColor"
                  fill-opacity="0.18"></path>
                <path
                  [attr.d]="trendAreaPath('web')"
                  [attr.fill]="trendWebColor"
                  fill-opacity="0.16"></path>
                <path
                  [attr.d]="trendLinePath('apps')"
                  fill="none"
                  [attr.stroke]="trendAppColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  vector-effect="non-scaling-stroke"></path>
                <path
                  [attr.d]="trendLinePath('web')"
                  fill="none"
                  [attr.stroke]="trendWebColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  vector-effect="non-scaling-stroke"></path>
              </svg>
              <span
                class="exw-rpt-trend-dot"
                *ngFor="let point of trendPoints('apps'); trackBy: trackByTrendPoint"
                [style.left.%]="point.x"
                [style.top.%]="point.y"
                [style.background]="trendAppColor"></span>
              <span
                class="exw-rpt-trend-dot"
                *ngFor="let point of trendPoints('web'); trackBy: trackByTrendPoint"
                [style.left.%]="point.x"
                [style.top.%]="point.y"
                [style.background]="trendWebColor"></span>
            </div>
            <span class="exw-rpt-trend-corner" aria-hidden="true"></span>
            <div class="exw-rpt-trend-x" aria-hidden="true">
              <span *ngFor="let day of workday.dailyTrend">{{ day.label }}</span>
            </div>
          </div>
        </section>
      </div>

      <section class="exw-rpt-table-card">
        <div class="exw-rpt-table-toolbar">
          <h3>Detailed Usage</h3>
          <div class="exw-rpt-table-controls" aria-hidden="true">
            <div class="exw-rpt-search">
              <span class="material-symbols-outlined">search</span>
              <span>Search apps &amp; websites...</span>
            </div>
            <div class="exw-rpt-toggle">
              <span class="is-active">
                <span class="material-symbols-outlined">grid_view</span>
                By App/Website
              </span>
              <span>
                <span class="material-symbols-outlined">person</span>
                By Employee
              </span>
            </div>
            <span class="exw-rpt-export">
              <span class="material-symbols-outlined">download</span>
              Export
            </span>
          </div>
        </div>

        <div class="exw-rpt-table-wrap">
          <table class="exw-rpt-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Type</th>
                <th>Total Time</th>
                <th>Shift Time</th>
                <th>Overtime</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of rankedUsageRows; let i = index; trackBy: trackByUsageName">
                <td>{{ i + 1 }}</td>
                <td>{{ row.name }}</td>
                <td>
                  <span
                    class="exw-rpt-type"
                    [style.background]="appTypeColors[usageTypeLabel(row)].background"
                    [style.color]="appTypeColors[usageTypeLabel(row)].text"
                    [style.border-color]="appTypeColors[usageTypeLabel(row)].text">
                    {{ usageTypeLabel(row) }}
                  </span>
                </td>
                <td>{{ row.duration }}</td>
                <td>{{ row.duration }}</td>
                <td>00h 00m</td>
                <td>
                  <span class="exw-rpt-view">
                    <span class="material-symbols-outlined">visibility</span>
                    View
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="exw-rpt-pager" aria-hidden="true">
          <span>Items per page: {{ rankedUsageRows.length }}</span>
          <span>1–{{ rankedUsageRows.length }} of {{ rankedUsageRows.length }}</span>
        </div>
      </section>
    </div>

    <!-- Hours: Timesheet KPIs -->
    <div class="exw-hours" *ngIf="currentStep.id === 'hours'">
      <div class="exw-ts-toolbar" aria-hidden="true">
        <div class="exw-ts-date">
          <span class="material-symbols-outlined">chevron_left</span>
          <strong>1 Sep 2026</strong>
          <span class="material-symbols-outlined">chevron_right</span>
          <span class="material-symbols-outlined exw-ts-cal">calendar_month</span>
        </div>
        <div class="exw-ts-segments">
          <span class="is-active">Day-wise</span>
          <span>User-wise</span>
          <span>Period-wise</span>
        </div>
        <div class="exw-ts-actions">
          <span class="exw-ts-chip">By App</span>
          <span class="exw-ts-chip">By Website</span>
          <span class="exw-ts-export">
            <span class="material-symbols-outlined">download</span>
            Export
          </span>
        </div>
      </div>

      <div class="exw-ts-context">
        <span class="exw-ts-context-label">Showing:</span>
        Day-wise report for 01 Sep 2026
      </div>
      <p class="exw-ts-hint">
        Timesheet: Tracked Time is Usage Time + Idle Time. Offline Time is shown separately.
      </p>

      <div class="exw-hours-grid">
        <div class="exw-hours-card" *ngFor="let row of workday.hours" [attr.data-metric]="row.label">
          <span>{{ row.label }}</span>
          <strong>{{ row.value }}</strong>
        </div>
      </div>

      <div class="exw-ts-table-wrap">
        <table class="exw-ts-table">
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Employee Name</th>
              <th>First Activity</th>
              <th>Last Activity</th>
              <th>Usage Time</th>
              <th>Idle Time</th>
              <th>Offline Time</th>
              <th>Tracked Time</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of workday.timesheetRows; let i = index" [class.is-focus]="row.highlight">
              <td>{{ i + 1 }}</td>
              <td>
                <span class="exw-ts-name">{{ row.employeeName }}</span>
              </td>
              <td>{{ row.firstActivity }}</td>
              <td>{{ row.lastActivity }}</td>
              <td>{{ row.usageTime }}</td>
              <td>{{ row.idleTime }}</td>
              <td>{{ row.offlineTime }}</td>
              <td>{{ row.trackedTime }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Trends: real Productivity Trends chrome (Overview / Attention / Deep Work) -->
    <div class="exw-trends" *ngIf="currentStep.id === 'trends'">
      <app-example-productivity-trends-preview [trends]="workday.trends"></app-example-productivity-trends-preview>
    </div>

    <!-- Insights -->
    <div class="exw-insights" *ngIf="currentStep.id === 'insights'">
      <div class="exw-insights-note">{{ workday.insightsPreviewNote }}</div>
      <div class="exw-insights-split">
        <div class="exw-insights-copy">
          <h3>{{ workday.insightsHeadline }}</h3>
          <ul class="exw-insights-points">
            <li *ngFor="let point of workday.insightsPoints">
              <strong>{{ point.title }}</strong>
              <p>{{ point.body }}</p>
            </li>
          </ul>
        </div>
        <div class="exw-insights-frame-wrap" *ngIf="insightsUrl">
          <div class="exw-insights-frame-label">Email preview</div>
          <iframe class="exw-insights-frame" [src]="insightsUrl" title="Daily Insights format preview" loading="lazy"></iframe>
        </div>
      </div>
    </div>
  </div>

  <footer class="exw-footer">
    <div class="exw-nav">
      <button mat-stroked-button type="button" (click)="previous()" [disabled]="isFirst">Previous</button>
    </div>
    <div class="exw-cta">
      <ng-container *ngIf="!isLast; else lastCta">
        <p class="exw-next-hint" *ngIf="currentStep.nextHint">{{ currentStep.nextHint }}</p>
        <button mat-flat-button class="exw-btn-primary" type="button" (click)="next()">
          Next
          <mat-icon fontSet="material-symbols-outlined">arrow_forward</mat-icon>
        </button>
      </ng-container>
      <ng-template #lastCta>
        <p class="exw-cta-payoff">{{ primaryCtaSupport }}</p>
        <button mat-flat-button class="exw-btn-primary" type="button" (click)="tryOneEmployee()">
          {{ primaryCtaLabel }}
          <mat-icon fontSet="material-symbols-outlined">arrow_forward</mat-icon>
        </button>
      </ng-template>
    </div>
  </footer>
</div>
</div>
